import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Cache/speed icon.
 *
 * A lightning bolt shape representing speed and caching. Recognizable
 * as a cache/speed symbol used for fast data access layers.
 *
 * Dual-tone layered:
 * - Outline: currentColor, 2px stroke, round caps/joins
 * - Bolt body: cyan accent fill at 12%
 */
export const CacheIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Lightning bolt with cyan accent fill */}
    <path
      d="M13 2 L4 14 L11 14 L9 22 L20 10 L13 10 Z"
      fill="#00d4ff"
      fillOpacity={0.12}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

CacheIcon.displayName = "CacheIcon";

export default CacheIcon;
